.styledDropdown {
  [data-dropdown-list] {
    box-shadow: none;
    border: none;
    background-color: var(--background-soft);
    max-width: 660px;
    overflow-x: hidden;
    padding-left: 8px;
    border-radius: 12px;
  }
}
